import React from 'react';
import { BulletsListInput } from './BulletsListInput';

interface BulletsFieldProps {
  label: string;
  required?: boolean;
  value: string[];
  onChange: (_items: string[]) => void;
  error?: string;
}

export const BulletsField: React.FC<BulletsFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <BulletsListInput value={value} onChange={onChange} />
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
    </div>
  );
};

